module.exports = __webpack_public_path__ + "static/img/irole.440fa27.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/qa/irole.png
// module id = ZVxF
// module chunks = 7